import {
  Component,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { FlowResponse, ResponseUpdateItem } from '@sondermind/utilities/models-flows';
import { FlowsHostSegmentEvents, IFlowsHostSegmentSchema, WizardService } from '@sondermind/flows-host';
import { SegmentService } from '@sondermind/segment';
import { ConfigurationService } from '@sondermind/configuration';
import { IntakeStepComponent } from '../intake-step.component';

@Component({
  selector: 'app-intake-sign-up',
  templateUrl: './intake-sign-up.component.html',
  styleUrls: ['./intake-sign-up.component.scss']
})

export class IntakeSignUpComponent extends IntakeStepComponent implements OnInit, OnDestroy {
  @Input() response: FlowResponse;

  constructor(
    private configurationService: ConfigurationService,
    private auth0: AuthService,
    private segmentService: SegmentService<IFlowsHostSegmentSchema>,
    private wizardService: WizardService
  ) {
    super(wizardService);
  }

  async ngOnInit(): Promise<void> {
    const anonymousId = await this.segmentService.anonymousId();

    // this event is intermittently not getting emitted without the await
    await this.segmentService.track<FlowsHostSegmentEvents.MATCH_FLOW_REDIRECTED_TO_AUTH0>(
      FlowsHostSegmentEvents.MATCH_FLOW_REDIRECTED_TO_AUTH0,
      { flow: this.response.slug }
    ).catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Error tracking match flow redirected to auth0', error);
    });

    this.auth0.loginWithRedirect({
      authorizationParams: {
        scope: 'offline_access',
        screen_hint: 'signup',
        signup_type: 'match_flow',
        fwr_uuid: this.response.key,
        slug: this.response.slug,
        first_name: this.response.data.contactFirstName,
        last_name: this.response.data.contactLastName,
        anonymous_id: anonymousId,
        eeNamespace: this.configurationService.env.eeNamespace
      }
    });
  }

  onSubmit(): ResponseUpdateItem[] {
    return [];
  }
}
